import { Button, Link, Paper, styled, Typography } from '@mui/material';

interface StyleProps {
  isProcessManagementForm: boolean;
}

const FormPaper = styled(Paper, {
  shouldForwardProp: prop => prop !== 'isProcessManagementForm',
})<StyleProps>(({ theme, isProcessManagementForm }) => ({
  width: '100%',
  maxWidth: 600,
  boxSizing: 'border-box',
  padding: isProcessManagementForm ? '0' : theme.spacing(3),
  backgroundColor: isProcessManagementForm ? 'transparent' : undefined,

  '& h2': {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
    fontSize: '1.125rem',
  },
  '& .scar-textField': {
    marginBottom: theme.spacing(2),
  },
  '& input::-ms-reveal': {
    display: 'none',
  },
}));

const SubmitButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(1),
  fontSize: '0.875rem',
}));

const ForgotPasswordLink = styled(Link)(({ theme }) => ({
  marginTop: theme.spacing(1),
  display: 'block',
  cursor: 'pointer',
}));

const TermsRow = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  fontSize: '0.75rem',
  gap: '1.5em',
  justifyContent: 'center',
  marginTop: theme.spacing(2),
}));

const ManageCookieLink = styled(Link)({
  cursor: 'pointer',
  textDecoration: 'none',
});

const SignupLink = styled(Link)({
  marginLeft: '2em',
});

const OrText = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

const PageWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: `calc(100dvh - ${theme.spacing(16)})`,
  width: '100%',
  gap: theme.spacing(3),
}));

const ContentWrapper = styled('div')({
  alignItems: 'center',
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  justifyContent: 'center',
});

const FooterWrapper = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
}));

export {
  ContentWrapper,
  FooterWrapper,
  ForgotPasswordLink,
  FormPaper,
  ManageCookieLink,
  OrText,
  PageWrapper,
  SignupLink,
  SubmitButton,
  TermsRow,
};
